import * as React from 'react';
import { VStack } from '@chakra-ui/react';
import {
  IScoreboardBranding,
  IScoreboardDisplayConfig,
  IScoreboardTheme,
} from '../types';
import { BackgroundSection } from './BackgroundSection';
import { BrandingSection } from './BrandingSection';
import { ColorsSection } from './ColorsSection';
import { DisplaySection } from './DisplaySection';

interface AppearanceTabContentProps {
  theme: IScoreboardTheme;
  display: IScoreboardDisplayConfig;
  branding: IScoreboardBranding;
  uploadingLogo: boolean;
  uploadError: string | null;
  onClearUploadError: () => void;
  onUpdateTheme: (updates: Partial<IScoreboardTheme>) => void;
  onUpdateDisplay: (updates: Partial<IScoreboardDisplayConfig>) => void;
  onUpdateBranding: (updates: Partial<IScoreboardBranding>) => void;
  onLogoUpload: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const AppearanceTabContent = ({
  theme,
  display,
  branding,
  uploadingLogo,
  uploadError,
  onClearUploadError,
  onUpdateTheme,
  onUpdateDisplay,
  onUpdateBranding,
  onLogoUpload,
}: AppearanceTabContentProps): React.ReactElement => (
  <VStack gap={5} align='stretch'>
    <ColorsSection theme={theme} onUpdate={onUpdateTheme} />
    <BackgroundSection theme={theme} onUpdate={onUpdateTheme} />
    <DisplaySection
      theme={theme}
      display={display}
      onUpdateTheme={onUpdateTheme}
      onUpdateDisplay={onUpdateDisplay}
    />
    <BrandingSection
      branding={branding}
      uploadingLogo={uploadingLogo}
      uploadError={uploadError}
      onClearUploadError={onClearUploadError}
      onUpdate={onUpdateBranding}
      onLogoUpload={onLogoUpload}
    />
  </VStack>
);
